import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useForm } from "react-hook-form";
import { ReactSession } from 'react-client-session';
import LoadingBar from 'react-top-loading-bar'
import { GoogleLogin } from 'react-google-login';
import GoogleLoginButton from "../Global/GoogleLoginButton";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { gapi } from 'gapi-script';
import {Helmet} from "react-helmet";

import classes from './Login.module.css';

function Login() {
  const navigate = useNavigate();
  const {register, handleSubmit, formState: { errors }} = useForm();
  const [progress, setProgress] = useState(100);
  // const [key, setKey] = useState('');
  // const [email, setEmail] = useState('');
  const [ifDisabled, setIfDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [msg, setMsg] = useState({
    'status': '',
    'message': ''
  })
  ReactSession.setStoreType("localStorage");

  const activeAccount = () => {
    let url = new URLSearchParams(window.location.search);
    let email = url.get("m");
    let key = url.get("k");
    
    // setEmail(email);
    // setKey(key);
  
    if(email && key) {
      axios.post(`${process.env.REACT_APP_API_URL}/api/login.php`,
        {
          email: email,
          key: key,
          action: 'ACTIVE_ACCOUNT'
        },
        {
            headers: {
            "Content-Type": "multipart/form-data",
            }
        }).then(res => {
          setIsLoading(false);
          setMsg({
            status: res.data.status,
            message: res.data.message
          })
        })
    }
  }

  useEffect(() => {
    const logged_user = ReactSession.get("logged_user");
    logged_user && navigate("/dashboard");

    isLoading && activeAccount();
  }, []);

  useEffect(() => {
    function start() {
      gapi.client.init({
        clientId: process.env.REACT_APP_GOOGLE_LOGIN_KEY,
        scope: 'email',
      });
    }

    gapi.load('client:auth2', start);
  }, []);
  
  const onSubmit = (data) => {
    setIfDisabled(true);

    const toast_id = toast.loading("Please wait...");
    axios.post(`${process.env.REACT_APP_API_URL}/api/login.php`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(res => {
      if(res.data.status === "success"){
        if(res.data.data.status === '0') {
          navigate("/verifyemail?m=" + res.data.data.m + "&k=" + res.data.data.k);
        }else {
          ReactSession.set("logged_user", res.data.data.id);
          ReactSession.set("message", res.data.data.message);
          ReactSession.set("group", res.data.data.group);
          ReactSession.set("name", res.data.data.name);
          ReactSession.set("username", res.data.data.username);
          ReactSession.set("avatar", res.data.data.avatar);

          navigate("/dashboard");
        }
      }else {
        toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false, closeOnClick: true, rtl: true});
      }

      setIfDisabled(false);
    })
    .catch(err => {
      console.log(err);
    })
  }

  // const responseGoogle = (response) => {
  //   console.log(response);
  // }

  const onSuccess = response => {
    const data = new FormData();
    data.append("type", 'google');
    data.append("gid", response.profileObj.googleId);
    data.append("name", response.profileObj.name);
    data.append("email", response.profileObj.email);
    data.append("avatar", response.profileObj.imageUrl);
    data.append("ref", '');

    axios.post(`${process.env.REACT_APP_API_URL}/api/login.php`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(res => {
      if(res.data.status === "success"){
        ReactSession.set("logged_user", res.data.data.id);
        ReactSession.set("message", res.data.data.message);
        ReactSession.set("group", res.data.data.group);
        ReactSession.set("name", res.data.data.name);
        ReactSession.set("username", res.data.data.username);
        ReactSession.set("avatar", res.data.data.avatar);

        navigate("/dashboard");
      }else {
        setMsg({
          status: '',
          message: '',
        })
        toast(res.data.message, {type: res.data.status, autoClose: 5000});
      }
    })
    .catch(err => {
      console.log(err);
    })
  };
  const onFailure = response => {
    console.log('FAILED', response);
  };

  const responseFacebook = (response) => {
    console.log(response);
  }

  return (
    <>
      <Helmet>
          <title>Wesharez Login</title>
          <meta name="description" content="Share your web pages, articles, blog entries, photographs, and videos with friends, family, and the world on Wesharez." />
          <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
      </Helmet>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <ToastContainer />
      <div className={classes.login_component}>
        <div className="container">
            <div className={classes.form_header}>
              <div className={classes.main_logo25} id="logo">
                <Link to='/'><img src={`${process.env.REACT_APP_API_URL}/storage/uploads/wesharez-pl-png5e9ace7d1bbda.png`} alt="" /></Link>
              </div>
            </div>
            <div className={classes.login_form}>
              <div className={`${classes.header} mb-4`}>
                <h3 className="text-center">Login</h3>
              </div>
              { msg.status !== '' && msg.message !== '' && <div className={`alert alert-${msg.status}`} role="alert">{msg.message}</div> }
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group mb-3">
                  <label>Email</label>
                  <input {...register('email', {required: true})} type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
                  {errors.email && <p className={classes.error_msg}>This field cannot be empty</p>}
                </div>
                <div className="form-group mb-3">
                  <label>Password</label>
                  <input {...register('password', {required: true})} type="password" className="form-control" id="exampleInputPassword1" placeholder="Password" />
                  {errors.password && <p className={classes.error_msg}>This field cannot be empty</p>}
                </div>
                <div className="form-group form-check mb-3">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label className="form-check-label" htmlFor="exampleCheck1">Remember Me</label>
                </div>
                <input {...register('type')} type="hidden" value='core' />
                <div className="form-group mb-2">
                    <button className={`btn btn-primary btn-block ` + classes.login_btn} type="submit" disabled={ifDisabled}>Sign In</button>
                </div>
                <Link className={classes.reset_pass} to='/forgot-password'>Forgot password?</Link>
              </form>
              <div className={classes.google_login}>
                <span className="text-muted mt-4 mb-1 d-block">Or Sign in with social platforms</span>
                <div className="mb-2">
                  <GoogleLogin
                    clientId="572179960768-7273o50dvaj9sdnqr089fff3l5phjfkh.apps.googleusercontent.com"
                    render={renderProps => GoogleLoginButton(renderProps)}
                    onSuccess={onSuccess}
                    onFailure={onFailure}
                  />
                </div>
                {/* <div className="">
                  <FacebookLogin
                    appId="1526493084474241"
                    autoLoad
                    callback={responseFacebook}
                    render={renderProps => FacebookLoginButton(renderProps)}
                  />
                </div> */}
              </div>
              <p className="mb-0 mt-4">Don't have an account? <Link className={classes.signup_link} to="/register">Sign Up</Link></p>
            </div>
            <div className={classes.form_footer}>
              <p>© 2020 <strong>Wesharez</strong>. All Rights Reserved.</p>
            </div>
        </div>
      </div>
    </>
  );
}

export default Login;